export default __webpack_public_path__ + "static/media/athleteRecruitNotice.0f7f3aab.jpg";